<template>
  <div v-if="isScrolled">
    <a class="scrollToTop__button" @click="scrollToTop">
      <slot></slot>
    </a>
  </div>
</template>

<script>
    export default {
        name: 'ScrollToTop',
        data() {
            return {
                isScrolled: false,
            };
        },
        mounted() {
            this.handleScroll();
        },
        created() {
            window.addEventListener('scroll', this.handleScroll);
        },
        destroyed() {
            window.removeEventListener('scroll', this.handleScroll);
        },
        methods: {
            scrollToTop() {
                document.body.scrollTop = 0;
                document.documentElement.scrollTop = 0;
            },
            handleScroll() {
                this.isScrolled = (document.body.scrollTop > 20 || document.documentElement.scrollTop > 20);
            },
        },
    };
</script>
